import { useMemo } from 'react';
import { ModuleHelper } from 'src/modules/contentList/helpers';
export function useSelectedContentCount({ modules, pages, selectedModules, selectedPages }) {
    const totalPagesByModule = useMemo(() => ModuleHelper.getTotalPagesByModule(modules), [modules]);
    return useMemo(() => {
        if (!modules || !pages)
            return 0;
        let total = 0;
        // Count total pages from selected modules + the module itself
        total += Object.entries(selectedModules).reduce((acc, [moduleId, selected]) => {
            return selected ? acc + (totalPagesByModule[moduleId] || 0) + 1 : acc;
        }, 0);
        // Count selected pages not belonging to selected modules
        total += Object.entries(selectedPages).reduce((acc, [pageId, selected]) => {
            if (!selected) {
                return acc;
            }
            const moduleId = pages?.find((page) => page.id === pageId)?.moduleId;
            return !moduleId || !selectedModules[moduleId] ? acc + 1 : acc;
        }, 0);
        return total;
    }, [modules, pages, selectedModules, selectedPages, totalPagesByModule]);
}
